import React from "react";
import CollectionList from "./collection-list";

const Collection = ({ username, collections }) => (
    <React.Fragment>
        <header className="display-flex col-xs-12">
            <h3 className="ui_collections">Collections</h3>
            <div className="back-link">
                <a className="text-link" href={`/${username}/collections`}>
                    View all collections
                </a>
            </div>
        </header>

        <div className="col-xs-12">
            <CollectionList collections={collections} />
        </div>
    </React.Fragment>
);

const DashboardCollectionSection = ({ showIcons, collections, username }) => {
    if (showIcons) {
        return (
            <section
                id="user-collections"
                className="profile-section container row"
            >
                <div className="container row">
                    {collections && collections.length ? (
                        <Collection
                            username={username}
                            collections={collections}
                        />
                    ) : (
                        <React.Fragment>
                            <header className="display-flex">
                                <h3 className="ui_collections">Collections</h3>
                            </header>
                            <a
                                className="upload-new light ui_plus-circle-no-fill"
                                href="/upload"
                            >
                                Upload a collection
                            </a>
                        </React.Fragment>
                    )}
                </div>
            </section>
        );
    }

    return null;
};

export default DashboardCollectionSection;
